module.exports = __webpack_public_path__ + "static/media/inoltrato.204ffdaa.svg";